export default __webpack_public_path__ + "667e5dcc844979a192cef6823e8f0abd.svg";